<template>
  <div class="settings-landing d-flex justify-content-center">
    <div class="d-flex justify-content-between landing-content mt-5 pt-5">
      <img src="@/assets/images/settingsLanding.svg" alt="" width="300" />
      <div class="text-area d-flex flex-column justify-content-center">
        <h3 class="title">Paramètres</h3>
        <p>Bienvenue dans la page de parametres. Vous pouvez personaliser vos informations ainsi que celles de l'application.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style>
.landing-content {
  width: 700px;
}
.text-area .title {
    color: #5a58c3;
    font-family: main-bold
}
</style>
